<template>
  <div class="input-wrapper">
    <div class="input-label" v-if="label">
      <div class="label-text">{{ label }}</div>
    </div>
    <div
      class="select-block"
      @click.stop="showOptions()"
      v-click-outside="hideOptions"
      :class="{'disabled': disabled}"
    >
      <input
        type="text"
        class="input"
        :disabled="disabled"
        v-model="inputValue"
        :placeholder="placeholder"
        :name="name"
        :class="{'input-disabled': disabled}"
        autocomplete="off"
        readonly
      />
      <img
        src="../../../public/custom/images/arrow-down.svg"
        alt="Arrow down image"
      />
      <div class="dropdown-menu" :class="{'scrollable': optionsList.length > 3}" v-if="isShowOptions">
        <div
          v-for="option of optionsList"
          :key="option"
          class="option"
          @click.stop="chooseOption(option)"
        >
          {{ $t(`${dictionaryPath}${option}`) }}
        </div>
      </div>
    </div>
    <div class="error-block"></div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";

export default {
  name: "BaseSelect",
  props: {
    label: String,
    placeholder: String,
    defaultValue: String,
    optionsList: Array,
    dictionaryPath: String,
    disabled: {
      type: Boolean,
      default: false
    },
    name: String,
  },
  directives: {
    ClickOutside,
  },
  data() {
    return {
      inputValue: this.defaultValue ? this.$t(`${this.dictionaryPath}${this.defaultValue}`) : '',
      isShowOptions: false,
    };
  },
  methods: {
    showOptions() {
      if (!this.disabled) {
        this.isShowOptions = true;
      }
    },
    chooseOption(value) {
      this.inputValue = this.$t(`${this.dictionaryPath}${value}`);
      this.hideOptions();
      this.$emit("input", value);
    },
    hideOptions() {
      this.isShowOptions = false;
    },
  },
  watch: {
    defaultValue(value) {
      this.inputValue = value ? this.$t(`${this.dictionaryPath}${value}`) : '';
    }
  }
};
</script>

<style lang="scss" scoped>
.input-wrapper {
  @include base-input-wrapper;
}

.input-label {
  @include base-input-label;
}

.select-block {
  width: 100%;
  height: 42px;
  padding-right: 9px;
  box-sizing: border-box;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  background-color: #ffffff;
  border-radius: 6px;
  border: 1px solid #CDCDCD;
}

.input {
  width: 100%;
  height: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  background-color: transparent;
  cursor: pointer;
  user-select: none;
  caret-color: transparent;
  border-radius: 6px;
  border: none;
  outline: none;
  font-size: 16px;
  line-height: 135%;
  color: #555555;

  &:focus {
    border: none;
    outline: none;
  }
}

.error-block {
  @include base-input-error-block;
}

.dropdown-menu {
  width: calc(100% + 2px);
  height: auto;
  max-height: 230px;
  overflow: auto;
  box-sizing: border-box;
  position: absolute;
  top: calc(100% - 1px);
  left: -1px;
  background-color: #ffffff;
  border-radius: 6px;
  border: 1px solid #CDCDCD;
  z-index: 2;
  cursor: pointer;
}

.scrollable {
  border-radius: 6px 0 0 6px;
}

.option {
  height: 42px;
  padding: 6px 10px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  font-weight: 400;
  font-size: 16px;
  line-height: 135%;
  cursor: pointer;
}

.option:hover {
  background-color: #CDCDCD;
}

.option:first-of-type {
  border-radius: 6px 6px 0 0;
}

.option:last-of-type {
  border-radius: 0 0 6px 6px;
}

.dropdown-menu::-webkit-scrollbar {
    width: 3px;
    height: 10px;
    margin-right: 5px;
    scroll-padding-top: 5px;
}

.dropdown-menu {
    scroll-padding-top: 5px;
}

.dropdown-menu::-webkit-scrollbar-track {
    background-color: #ECEEF0;
    border-radius: 20px;
}

.dropdown-menu::-webkit-scrollbar-thumb {
    background-color: #878787;
    border-radius: 20px;
}

.disabled {
  background-color: rgba(239, 239, 239, 0.3);
  cursor: default;
}

.input-disabled {
  background-color: transparent !important;
  cursor: default;
}
</style>
